export function formSubmitFetch(formName, async) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SUBMIT_FETCH',
                formName,
                async,
            })
        );
}

export function formSubmitReset(formName, resetValues = true) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SUBMIT_RESET',
                formName,
                resetValues,
            })
        );
}

export function registerForm(formName) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_REGISTER',
                formName,
            })
        );
}

export function unregisterForm(formName) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_UNREGISTER',
                formName,
            })
        );
}

export function setFieldValue(formName, fieldName, value, operator) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SET_FIELD_VALUE',
                fieldName,
                formName,
                operator,
                value,
            })
        );
}

export function setFieldValues(formName, values, resetValues = true) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SET_VALUES',
                formName,
                resetValues,
                values,
            })
        );
}

export function setFormRequestPath(formName, requestPath) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'SET_FORM_REQUEST_PATH',
                formName,
                requestPath,
            })
        );
}

export function unregisterFieldValue(formName, fieldName) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_UNREGISTER_FIELD_VALUE',
                fieldName,
                formName,
            })
        );
}

export function setFieldErrors(formName, fieldName, errors) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SET_FIELD_ERRORS',
                fieldName,
                formName,
                errors,
            })
        );
}

export function unregisterFieldErrors(formName, fieldName) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_UNREGISTER_FIELD_ERRORS',
                fieldName,
                formName,
            })
        );
}

export function unregisterFormErrors(formName) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_UNREGISTER_FORM_ERRORS',
                formName,
            })
        );
}

export function setFormSubmitted(actionShouldFetch, formName, servicesDataKey, submitted) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SUBMITTED',
                actionShouldFetch,
                formName,
                servicesDataKey,
                submitted,
            })
        );
}

export function resetForm(formName, submitted = true, resetValues = false) {
    return dispatch =>
        Promise.resolve(
            dispatch({
                type: 'FORM_RESET',
                formName,
                submitted: !!submitted,
                resetValues,
            })
        );
}
